import React from 'react';
import { Hidden } from '@material-ui/core';
import { AppFooter } from './ecd-app-footer';
import { AppHeader } from './ecd-app-header';
import { AppNavigation } from './ecd-app-navigation';
import { LayoutModels } from './layout-models';
import { MobileAppNavigation } from './ecd-mobile-navigation';


export const withLayout = (layout: LayoutModels = LayoutModels.FULL_WIDTH) => (WrappedComponent: React.ComponentType) => {

    return (props: React.PropsWithChildren<any>) => {

        switch (layout) {
            case LayoutModels.NO_LAY_OUT:
                return (
                    <WrappedComponent {...props}>
                        {props.children}
                    </WrappedComponent>
                );
            case LayoutModels.NO_NAVIGATION:
                return (
                    <>
                        <AppHeader />
                        <div className='ecd-page'>
                            <div className='ecd-page-content'>
                                <WrappedComponent {...props}>
                                    {props.children}
                                </WrappedComponent>
                                <AppFooter />
                            </div>
                        </div>
                    </>
                );
            case LayoutModels.FULL_WIDTH:
            default:
                return (
                    <>
                        <Hidden smDown>
                            <AppHeader />
                        </Hidden>
                        <Hidden mdUp>
                            <MobileAppNavigation />
                        </Hidden>
                        <div className='ecd-page'>
                            <Hidden smDown>
                                <div className='ecd-page-sidebar'>
                                    <AppNavigation />
                                </div>
                            </Hidden>
                            <div className='ecd-page-content'>
                                <WrappedComponent {...props}>
                                    {props.children}
                                </WrappedComponent>
                                <AppFooter />
                            </div>
                        </div>
                    </>
                );
        }
    };
};
